var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{attrs:{"type":_vm.elstate,"size":"small"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.gotoTree($event)}}},[_vm._v(" "+_vm._s(_vm.eltext)+" "),_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }